// Single metric: label + big value. Reads `config.source` from the matter
// (e.g. "matter.bailStatus" → matter.workspace.bailStatus, with fallback
// to matter top-level fields). Shows "—" if the value is missing rather
// than rendering nothing — empty cards are louder than placeholder ones.

import { resolveSource, type WidgetProps } from "./types";
import { WidgetCard } from "./WidgetCard";

const ID_KEYS = new Set(["docketNumber", "caseNumber"]);

function fmt(v: unknown): string {
  if (v == null) return "—";
  if (typeof v === "number") return v.toLocaleString();
  if (typeof v === "string") return v;
  if (typeof v === "boolean") return v ? "Yes" : "No";
  return String(v);
}

export function MetricWidget({ config, matter }: WidgetProps) {
  const value = resolveSource(matter, config.source);
  const title = config.title ?? config.key ?? "Metric";
  const id = ID_KEYS.has(config.key ?? "");
  return (
    <WidgetCard title={title}>
      <div
        className={id ? "tnum-mono" : "tnum"}
        style={{
          fontSize: 22,
          fontWeight: 700,
          letterSpacing: id ? undefined : "-0.03em",
          color: value == null ? "var(--muted)" : "var(--ink)",
          lineHeight: 1.1,
        }}
      >
        {fmt(value)}
      </div>
    </WidgetCard>
  );
}
